import React from 'react';
import * as Ons from 'react-onsenui';
import NumericInput from '@hockeydata/numeric-input';
import Modal from '../Modal';
import PullHook from '../PullHook';
import PlayerList from '../../containers/PlayerList';
import { translate as _ } from '../../util/i18n';
import { expired, isAbsent } from '../../util';
import { getPlayerPositions, getTeamOfficialPositions, supports, wording } from '../../util/context';
import { showAlert } from '../../util/ui';
import { FACECHECK_ALLOWED, READY_TO_PLAY, ROSTERS_LOCKED, ROSTERS_UNLOCKED } from '../../store/constants/statusCodes';
import { CAPTAIN_A, CAPTAIN_C, POSITION_ALL_PLAYERS, POSITION_ALL_TEAM_OFFICIALS } from '../../store/constants/misc';

class RosterPlayers extends React.Component {

    #captainOptions;
    #playerPositions;
    #teamOfficialPositions;

    constructor( props ) {

        super( props );

        this.state = {
            activePlayer:                  null,
            jerseyNrEditorOpen:            false,
            playerActionsOpen:             false,
            lineupDataEditorOpen:          false,
            lineupDataEditorValueCaptain:  null,
            lineupDataEditorValueLine:     null,
            lineupDataEditorValuePosition: null,
            lineupDataEditorValueStarting: null
        };

        this.handleCaptainSelect          = this.handleCaptainSelect.bind( this );
        this.handleEditJerseyNrClick      = this.handleEditJerseyNrClick.bind( this );
        this.handleEditLineupDataClick    = this.handleEditLineupDataClick.bind( this );
        this.handleForceTakeFaceCheck     = this.handleForceTakeFaceCheck.bind( this );
        this.handleJerseyNrClick          = this.handleJerseyNrClick.bind( this );
        this.handleJerseyNrEditorCancel   = this.handleJerseyNrEditorCancel.bind( this );
        this.handleJerseyNrEditorClose    = this.handleJerseyNrEditorClose.bind( this );
        this.handleLineSelect             = this.handleLineSelect.bind( this );
        this.handleLineupDataEditorCancel = this.handleLineupDataEditorCancel.bind( this );
        this.handleLineupDataEditorClose  = this.handleLineupDataEditorClose.bind( this );
        this.handlePlayerActionsClose     = this.handlePlayerActionsClose.bind( this );
        this.handlePlayerActivate         = this.handlePlayerActivate.bind( this );
        this.handlePlayerClick            = this.handlePlayerClick.bind( this );
        this.handlePlayerRemoveClick      = this.handlePlayerRemoveClick.bind( this );
        this.handleStartingPlayerToggle   = this.handleStartingPlayerToggle.bind( this );
        this.handleTakeFaceCheck          = this.handleTakeFaceCheck.bind( this );
        this.handleToggleAbsent           = this.handleToggleAbsent.bind( this );
        this.handleToggleDNP              = this.handleToggleDNP.bind( this );

        this.#captainOptions        = [ null, CAPTAIN_C, CAPTAIN_A ];
        this.#playerPositions       = getPlayerPositions( props.context ) || [];
        this.#teamOfficialPositions = getTeamOfficialPositions( props.context ) || [];

    }

    handleCaptainSelect( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // this.setState( { lineupDataEditorValueCaptain: this.#captainOptions[ Number( e.index ) ] } );
        this.setState( { lineupDataEditorValueCaptain: this.#captainOptions[ Number( e.target.querySelector( 'input:checked' ).value ) ] } );

    }

    handleEditJerseyNrClick() {

        this.setState( {

            jerseyNrEditorOpen: true,
            playerActionsOpen:  false

        } );

    }

    handleEditLineupDataClick() {

        const newState = {

            playerActionsOpen:             false,
            lineupDataEditorOpen:          true,
            lineupDataEditorValuePosition: this.state.activePlayer.isTeamOfficial ? this.state.activePlayer.lineupData.job : this.state.activePlayer.lineupData.position

        };

        if ( ! this.state.activePlayer.isTeamOfficial ) {

            if ( supports( this.props.context, 'captain'        ) ) { newState.lineupDataEditorValueCaptain  = this.state.activePlayer.lineupData.captain;  }
            if ( supports( this.props.context, 'lineup'         ) ) { newState.lineupDataEditorValueLine     = this.state.activePlayer.lineupData.line;     }
            if ( supports( this.props.context, 'startingPlayer' ) ) { newState.lineupDataEditorValueStarting = this.state.activePlayer.lineupData.starting; }

        }

        this.setState( newState );

    }

    handleForceTakeFaceCheck() {

        showAlert( {

            buttonLabels: [ _( 'Abbrechen' ), _( 'OK' ) ],
            callback:     e => e === 1 && this.handleTakeFaceCheck(),
            cancelable:   true,
            message:      _( 'Dies übernimmt den Facecheck von:' ) + ' ' + this.props.facecheck,
            title:        _( 'Facecheck übernehmen?' )

        } );

    }

    handleJerseyNrClick( player ) {

        this.setState( {

            activePlayer:        player,
            jerseyNrEditorOpen:  true

        } );

    }

    handleJerseyNrEditorClose( e ) {

        this.props.onEditRosterPlayer( this.props.context, this.props.token, this.props.activeGame.id, this.props.team, this.props.teamId, { ...this.state.activePlayer, lineupData: { ...this.state.activePlayer.lineupData, jerseyNr: Number( e ) } } );

        this.setState( {

            activePlayer:       null,
            jerseyNrEditorOpen: false

        } );

    }

    handleJerseyNrEditorCancel() {

        this.setState( { jerseyNrEditorOpen: false } );

    }

    handleLineSelect( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // this.setState( { lineupDataEditorValueLine: Number( e.index ) || null } );
        this.setState( { lineupDataEditorValueLine: Number( e.target.querySelector( 'input:checked' ).value ) || null } );

    }

    handleLineupDataEditorCancel() {

        this.setState( { lineupDataEditorOpen: false } );

    }

    handleLineupDataEditorClose() {

        const lineupData = { ...this.state.activePlayer.lineupData };

        if ( this.state.activePlayer.isTeamOfficial ) {

            lineupData.job = this.state.lineupDataEditorValuePosition;

        } else {

            lineupData.position = this.state.lineupDataEditorValuePosition;

            if ( supports( this.props.context, 'lineup'         ) ) { lineupData.line     = this.state.lineupDataEditorValueLine     || null; }
            if ( supports( this.props.context, 'startingPlayer' ) ) { lineupData.starting = this.state.lineupDataEditorValueStarting || null; }
            if ( supports( this.props.context, 'captain'        ) ) { lineupData.captain  = this.state.lineupDataEditorValueCaptain  || null; }

        }

        this.props.onEditRosterPlayer( this.props.context, this.props.token, this.props.activeGame.id, this.props.team, this.props.teamId, { ...this.state.activePlayer, lineupData } );

        this.setState( {

            activePlayer:         null,
            lineupDataEditorOpen: false

        } );

    }

    handlePlayerActionsClose() {

        this.setState( { playerActionsOpen: false } );

    }

    handlePlayerActivate( player ) {

        this.props.onConfirmRosterPlayer( this.props.activeGame.id, player.id, ! player.isConfirmed );

    }

    handlePlayerClick( player ) {

        this.setState( {

            activePlayer:      player,
            playerActionsOpen: true

        } );

    }

    handlePlayerRemoveClick() {

        const callback = e => {

            e === 1 && this.props.onRemoveRosterPlayer( this.props.context, this.props.token, this.props.activeGame.id, this.props.activeGame.permission, this.state.activePlayer.id, this.state.activePlayer.isTeamOfficial );

            this.setState( { activePlayer: null } );

        };

        this.setState( { playerActionsOpen: false }, () => showAlert( {

            buttonLabels: [ _( 'Abbrechen' ), _( 'OK' ) ],
            cancelable:   true,
            message:      _( this.state.activePlayer.isTeamOfficial ? 'Team-Offiziellen entfernen?' : 'Spieler entfernen?' ),
            title:        '',

            callback

        } ) );

    }

    handlePositionSelect( e ) {

        this.setState( { lineupDataEditorValuePosition: e } );

    }

    handleStartingPlayerToggle( e ) {

        this.setState( { lineupDataEditorValueStarting: e.target.checked } );

    }

    handleTakeFaceCheck() {

        this.props.onTakeFaceCheck( this.props.context, this.props.token, this.props.activeGame.id, this.props.team, this.props.teamId );

    }

    handleToggleAbsent() {

        this.setPositionMeta( '#ABSENT' );

    }

    handleToggleDNP() {

        this.setPositionMeta( '#DNP' );

    }

    renderCountables() {

        const ret = [];

        this.props.countables.forEach( ( countable, i ) => {

            const counts = {};

            if ( this.props.roster && this.props.roster ) {

                this.props.roster.forEach( player => {

                    if ( ! countable.condition || countable.condition !== 'isConfirmed' || player.isConfirmed ) {

                        const value = ( countable.key in player ) ? player[ countable.key ] : "";

                        if ( ! countable.values || countable.values.indexOf( value ) !== -1 ) {

                            if ( ! ( value in counts ) ) {

                                counts[ value ] = 1;

                            } else {

                                counts[ value ]++;

                            }

                        }

                    }

                } );

            }

            const keys = Object.keys( counts );

            countable.title && ret.push( <h5 key={'title-' + i}>{countable.title}</h5> );

            if ( keys.length ) {

                keys.sort();

                ret.push(

                    <dl key={'list-' + i}>

                        {

                            keys.map( key => {

                                return (

                                    <div key={key}>

                                        <dt>{key}</dt>
                                        <dd>{counts[ key ]}</dd>

                                    </div>

                                );

                            } )

                        }

                    </dl>

                )

            } else {

                ret.push( <p key={'no-entries-' + i}>{_( 'Keine Einträge' )}</p> );

            }

        } );

        return ret;

    }

    renderInfo() {

        if ( this.props.activeGame.permission === 'referee' ) {

            if ( this.props.rosterStatus === READY_TO_PLAY ) {

                return (

                    <Ons.Card>
                        <h3><Ons.Icon icon="fa-play" /> {_( 'Ready to Play' )}</h3>
                        <p>{_( 'Der Facecheck ist abgeschlossen. Das Spiel ist Ready to Play.' )}</p>
                    </Ons.Card>

                );

            }

            if ( this.props.rosterStatus === ROSTERS_LOCKED ) {

                return (

                    <Ons.Card>
                        <h3><Ons.Icon icon="fa-lock" /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen gesperrt' : 'Roster gesperrt' )}</h3>
                        <p>{_( 'Die Teams können keine Spieler mehr hinzufügen oder bearbeiten. Der Facecheck kann durchgeführt werden.' )}</p>

                        {

                            ! this.props.facecheck ?

                                <>
                                    <p>{_( 'Facecheck übernehmen, um zu beginnen.' )}</p>
                                    <p><Ons.Button modifier="large" onClick={this.handleTakeFaceCheck}>{_( 'Facecheck übernehmen' )}</Ons.Button></p>
                                </>

                            : this.props.facecheck === FACECHECK_ALLOWED ?

                                <h3><i className="fas fa-spinner fa-spin" /> {_( 'Facechecking...' )}</h3>

                            :

                                <>
                                    <p>{_( 'Facecheck wird durchgeführt von:' )} {this.props.facecheck}</p>
                                    <p><Ons.Button modifier="large" onClick={this.handleForceTakeFaceCheck}>{_( 'Facecheck übernehmen' )}</Ons.Button></p>
                                </>

                        }

                    </Ons.Card>

                );

            }

            if ( this.props.rosterStatus === ROSTERS_UNLOCKED ) {

                return (

                    <Ons.Card>
                        <h3><Ons.Icon icon="fa-unlock" /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen offen' : 'Roster offen' )}</h3>
                        <p>{_( wording( this.props.context, 'lineup' ) ? 'Teams können Spieler hinzufügen und bearbeiten. Aufstellungen sperren, um mit dem Facecheck zu beginnen.' : 'Teams können Spieler hinzufügen und bearbeiten. Roster sperren, um mit dem Facecheck zu beginnen.' )}</p>
                    </Ons.Card>

                );

            }

            return (

                <Ons.Card>
                    <h3> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen in Vorbereitung' : 'Roster in Vorbereitung' )}</h3>
                    <p>{_( wording( this.props.context, 'lineup' ) ? 'Teams können noch keine Spieler hinzufügen oder bearbeiten. Aufstellungen öffnen, um den Teams die Bearbeitung zu ermöglichen.' : 'Teams können noch keine Spieler hinzufügen oder bearbeiten. Roster öffnen, um den Teams die Bearbeitung zu ermöglichen.' )}</p>
                </Ons.Card>

            );

        }

        if ( ! this.props.rosterStatus ) {

            return (

                <Ons.Card>
                    <h3><Ons.Icon icon="fa-lock" /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen in Vorbereitung' : 'Roster in Vorbereitung' )}</h3>
                    <p>{_( wording( this.props.context, 'lineup' ) ? 'Die Aufstellung muss erst vom Referee geöffnet werden. Es können noch keine Spieler hinzugefügt oder bearbeitet werden.' : 'Der Roster muss erst vom Referee geöffnet werden. Es können noch keine Spieler hinzugefügt oder bearbeitet werden.' )}</p>
                </Ons.Card>

            );

        }

        if ( this.props.rosterStatus === ROSTERS_UNLOCKED ) {

            return '';

        }

        return (

            <Ons.Card>
                <h3><Ons.Icon icon="fa-lock" /> {_( wording( this.props.context, 'lineup' ) ? 'Aufstellungen gesperrt' : 'Roster gesperrt' )}</h3>
                <p>{_( wording( this.props.context, 'lineup' ) ? 'Die Aufstellung wurde vom Referee gesperrt. Es können keine Spieler mehr hinzugefügt oder bearbeitet werden.' : 'Der Roster wurde vom Referee gesperrt. Es können keine Spieler mehr hinzugefügt oder bearbeitet werden.' )}</p>
            </Ons.Card>

        );

    }

    renderLimit( limit, key ) {

        let position = null;
        let current  = null;

        if ( limit.position === POSITION_ALL_PLAYERS ) {

            position = [ null, _( 'Spieler Gesamt' ) ];
            current  = this.props.roster ? this.props.roster.length : 0;

        } else if ( limit.position === POSITION_ALL_TEAM_OFFICIALS ) {

            position = [ null, _( 'Team-Offizielle Gesamt' ) ];
            current  = this.props.teamOfficials ? this.props.teamOfficials.length : 0;

        } else {

            position = this.#playerPositions.find( e => e[ 0 ] === limit.position )

            if ( position ) {

                current  = this.props.roster ? this.props.roster.filter( e => e.lineupData && e.lineupData.position === limit.position ).length : 0;

            } else {

                position = this.#teamOfficialPositions.find( e => e[ 0 ] === limit.position )

                if ( position ) {

                    current  = this.props.teamOfficials ? this.props.teamOfficials.filter( e => e.lineupData && e.lineupData.job === limit.position ).length : 0;

                }

            }

        }

        return (

            <React.Fragment key={key}>

                <dt>{position && position[1]}</dt>
                <dd>{current > limit.limit && <Ons.Icon icon="fa-exclamation-triangle" />} { current !== null && <span className='note'>{current} / </span>}{limit.limit}</dd>

            </React.Fragment>

        )

    }

    renderLimits() {

        if ( ! this.props.rosterLimits || ! this.props.rosterLimits.length ) {

            return;

        }

        return (

            <Ons.Card className="limits">

                <h5>{_( 'Limits' )}</h5>

                <dl>

                    {this.props.rosterLimits.map( ( e, i ) => this.renderLimit( e, i ) )}

                </dl>

            </Ons.Card>

        )

    }

    setPositionMeta( meta ) {

        let position = this.state.activePlayer.lineupData.position || '';
        const metas  = [ '#DNP', '#ABSENT' ];
        const exists = position.indexOf( meta ) !== -1;

        metas.forEach( m => { position = position.replace( m, '' ); } );

        if ( ! exists ) {

            position += meta;

        }

        this.props.onEditRosterPlayer( this.props.context, this.props.token, this.props.activeGame.id, this.props.team, this.props.teamId, { ...this.state.activePlayer, lineupData: { ...this.state.activePlayer.lineupData, position  } } );

        this.setState( {

            activePlayer:      null,
            playerActionsOpen: false

        } );


    }

    render() {

        // console.log( 'components.Pages.RosterPlayers.render()', this.props, this.state );

        const positions = this.state.activePlayer ? ( this.state.activePlayer.isTeamOfficial ? this.#teamOfficialPositions : this.#playerPositions ) : [];
          let sum       = [];

                                                           this.props.roster        && sum.push( this.props.roster.length        + ' ' + ( this.props.roster.length        === 1 ? _( 'Spieler', 'singular' ) : _( 'Spieler', 'plural' ) ) );
        supports( this.props.context, 'teamOfficials' ) && this.props.teamOfficials && sum.push( this.props.teamOfficials.length + ' ' + ( this.props.teamOfficials.length === 1 ? _( 'Team-Offizieller'    ) : _( 'Team-Offizielle'   ) ) );

        return (

            <>

                <Ons.Page>

                    <PullHook onChange={this.props.onPullHookChange} onLoad={this.props.onPullHookLoad} />

                    <h1 className="page-title">{wording( this.props.context, 'lineup' ) ? _( 'Aufstellung' ) : _( 'Roster', 'singular' )}</h1>

                    {this.renderInfo()}

                    {this.renderLimits()}

                    {this.props.roster && this.props.roster.length && this.props.countables && this.props.countables.length ? <Ons.Card className="countables">{this.renderCountables()}</Ons.Card> : ''}

                    {supports( this.props.context, 'teamOfficials' ) && <h2 className="page-subtitle">{_( 'Spieler', 'plural' )}</h2>}

                    {

                        this.props.roster && this.props.roster.length ?

                            <PlayerList
                                onPlayerActivate={player => this.props.activeGame.permission === 'referee' && ! this.props.disabled && ! isAbsent( player ) ? this.handlePlayerActivate : null}
                                onPlayerClick={! this.props.disabled ? this.handlePlayerClick : null}
                                onPlayerJerseyNrClick={! this.props.disabled && this.props.rosterStatus === ROSTERS_LOCKED ? this.handleJerseyNrClick : null}
                                playerIsActive={player => player.isConfirmed}
                                players={this.props.roster}
                                playersDisabled={this.props.disabled}
                                playersActivatable={player => this.props.playersActivatable && ! isAbsent( player )}
                                textActivatePlayer={_( 'Spieler confirmen' )}
                                textPlayerIsActive={[ <i className="fa fa-check" key="0" />, <span key="1"> </span>, <span key="3">{_( 'Spieler ist confirmed' )}</span> ]}
                                type="Players"
                            />

                        : ! expired( this.props.lastUpdate ) && (

                            this.props.activeGame.permission === 'referee' ?

                                <div className="no-items">
                                    <p>{_( 'Dieses Team hat noch keine Spieler hinzugefügt.' )}</p>
                                    <Ons.Button modifier="large" onClick={this.props.onLoadPlayers}>{_( 'Aktualisieren' )}</Ons.Button>
                                </div>

                            :

                                <div className="no-items">
                                    <h3>{_( wording( this.props.context, 'lineup' ) ? 'Aufstellung ist leer.' : 'Roster ist leer.' )}</h3>
                                    {this.props.rosterStatus === ROSTERS_UNLOCKED && this.props.activeGame.permission === this.props.team && <p>{_( 'Füge Spieler mit + hinzu.' )}</p>}
                                    <Ons.Button modifier="large" onClick={this.props.onLoadPlayers}>{_( 'Aktualisieren' )}</Ons.Button>
                                </div>

                        )

                    }

                    {supports( this.props.context, 'teamOfficials' ) && (

                        <>

                            <div className="spacer"></div>
                            <h2 className="page-subtitle">{_( 'Team-Offizielle' )}</h2>

                            {

                                this.props.teamOfficials && this.props.teamOfficials.length ?

                                    <PlayerList
                                        onPlayerActivate={teamOfficial => this.props.activeGame.permission === 'referee' && ! this.props.disabled ? this.handlePlayerActivate : null}
                                        onPlayerClick={! this.props.disabled ? this.handlePlayerClick : null}
                                        playerIsActive={teamOfficial => teamOfficial.isConfirmed}
                                        players={this.props.teamOfficials}
                                        playersDisabled={this.props.disabled}
                                        playersActivatable={teamOfficial => this.props.teamOfficialsActivatable}
                                        textActivatePlayer={_( 'Team-Offiziellen confirmen' )}
                                        textPlayerIsActive={[ <i className="fa fa-check" key="0" />, <span key="1"> </span>, <span key="3">{_( 'Team-Offizieller ist confirmed' )}</span> ]}
                                        type="TeamOfficials"
                                    />

                                : ! expired( this.props.lastUpdate ) && (

                                    this.props.activeGame.permission === 'referee' ?

                                        <div className="no-items">
                                            <p>{_( 'Dieses Team hat noch keine Team-Offiziellen hinzugefügt.' )}</p>
                                            <Ons.Button modifier="large" onClick={this.props.onLoadPlayers}>{_( 'Aktualisieren' )}</Ons.Button>
                                        </div>

                                    :

                                        <div className="no-items">
                                            <h3>{_( 'Liste ist leer.' )}</h3>
                                            {this.props.rosterStatus === ROSTERS_UNLOCKED && this.props.activeGame.permission === this.props.team && <p>{_( 'Füge Team-Offizielle mit + hinzu.' )}</p>}
                                            <Ons.Button modifier="large" onClick={this.props.onLoadPlayers}>{_( 'Aktualisieren' )}</Ons.Button>
                                        </div>

                                    )

                            }

                        </>

                    )}

                    <div className="spacer"></div>
                    <div className="sum">{sum.length ? _( 'Gesamt' ) + ': ' + sum.join( ', ' ) : ''}</div>

                </Ons.Page>

                <Ons.ActionSheet isOpen={this.state.playerActionsOpen && ! this.state.activePlayer.isTeamOfficial} isCancelable={true} onCancel={this.handlePlayerActionsClose}>
                    <Ons.ActionSheetButton onClick={this.handleEditLineupDataClick}>{_( 'Aufstellung bearbeiten' )}</Ons.ActionSheetButton>
                    <Ons.ActionSheetButton onClick={this.handleEditJerseyNrClick}>{_( 'Trikotnummer bearbeiten' )}</Ons.ActionSheetButton>
                    {supports( this.props.context, 'DNP' ) && <Ons.ActionSheetButton onClick={this.handleToggleDNP}>{this.state.activePlayer && this.state.activePlayer.position && this.state.activePlayer.position.indexOf( '#DNP' ) !== -1 && <Ons.Icon icon="fa-check" />} {_( 'Present, not Playing (PNP)' )}</Ons.ActionSheetButton>}
                    {this.props.activeGame.permission === 'referee' && <Ons.ActionSheetButton onClick={this.handleToggleAbsent} style={{ display: this.state.activePlayer && ! this.state.activePlayer.isConfirmed ? 'block' : 'none' }}>{isAbsent( this.state.activePlayer ) && <Ons.Icon icon="fa-check" />} {_( 'Abwesend' )}</Ons.ActionSheetButton>}
                    {this.props.activeGame.permission !== 'referee' && <Ons.ActionSheetButton onClick={this.handlePlayerRemoveClick}>{_( 'Spieler entfernen' )}</Ons.ActionSheetButton>}
                    <Ons.ActionSheetButton onClick={this.handlePlayerActionsClose}>{_( 'Abbrechen' )}</Ons.ActionSheetButton>
                </Ons.ActionSheet>

                <Ons.ActionSheet isOpen={this.state.playerActionsOpen && this.state.activePlayer.isTeamOfficial} isCancelable={true} onCancel={this.handlePlayerActionsClose}>
                    <Ons.ActionSheetButton onClick={this.handleEditLineupDataClick}>{_( 'Funktion bearbeiten' )}</Ons.ActionSheetButton>
                    {this.props.activeGame.permission !== 'referee' && <Ons.ActionSheetButton onClick={this.handlePlayerRemoveClick}>{_( 'Team-Offiziellen entfernen' )}</Ons.ActionSheetButton>}
                    <Ons.ActionSheetButton onClick={this.handlePlayerActionsClose}>{_( 'Abbrechen' )}</Ons.ActionSheetButton>
                </Ons.ActionSheet>

                {this.state.jerseyNrEditorOpen && <Modal><NumericInput onClose={this.handleJerseyNrEditorClose} onCancel={this.handleJerseyNrEditorCancel} value={this.state.activePlayer.jerseyNr}></NumericInput></Modal>}

                {this.state.lineupDataEditorOpen &&

                    <Ons.Dialog onCancel={this.handleLineupDataEditorCancel} isOpen={this.state.lineupDataEditorOpen} cancelable>

                        <div className="lineup-data-editor">

                            <h4>{_( this.state.activePlayer.isTeamOfficial ? 'Funktion' : 'Position' )}</h4>

                            <Ons.List
                                dataSource={positions}
                                renderRow={( position, idx ) =>

                                    <Ons.ListItem key={idx} modifier={idx === positions.length - 1 ? 'longdivider' : null} tappable={true} onClick={() => this.handlePositionSelect( position[ 0 ] )}>
                                        <div className="left"><span className="position-shortcut">{position[ 0 ]}</span></div>
                                        <div className="center">{position[ 1 ]}</div>
                                        <div className="right">{this.state.lineupDataEditorValuePosition === position[ 0 ] && <Ons.Icon icon='fa-check' />}</div>
                                    </Ons.ListItem>

                                }
                            />

                            {supports( this.props.context, 'lineup' ) && ! this.props.simpleLineup && ! this.state.activePlayer.isTeamOfficial &&

                                <div className="lineup-option">

                                    <h4>{_( 'Linie' )}</h4>

                                    <Ons.Segment index={Number( this.state.lineupDataEditorValueLine || 0 )} onPostChange={this.handleLineSelect}>

                                        <Ons.Button>-</Ons.Button>
                                        <Ons.Button>1</Ons.Button>
                                        <Ons.Button>2</Ons.Button>
                                        <Ons.Button>3</Ons.Button>
                                        <Ons.Button>4</Ons.Button>

                                    </Ons.Segment>

                                </div>

                            }

                            {supports( this.props.context, 'captain' ) && ! this.state.activePlayer.isTeamOfficial &&

                                <div className="lineup-option">

                                    <h4>{_( 'Kapitän' )}</h4>

                                    <Ons.Segment index={this.#captainOptions.findIndex( e => ! this.state.lineupDataEditorValueCaptain || e === this.state.lineupDataEditorValueCaptain )} onPostChange={this.handleCaptainSelect}>

                                        {this.#captainOptions.map( e => <Ons.Button key={'captain-' + e}>{e ? e : '-'}</Ons.Button> )}

                                    </Ons.Segment>

                                </div>

                            }

                            {supports( this.props.context, 'startingPlayer' ) && ! this.props.simpleLineup && ! this.state.activePlayer.isTeamOfficial &&

                                <div className="lineup-option">

                                    <label>

                                        <Ons.Checkbox onChange={this.handleStartingPlayerToggle} checked={!! this.state.lineupDataEditorValueStarting} style={{ float: 'left', marginRight: '10px' }} />

                                        <h4>{_( 'Startspieler' )}</h4>

                                    </label>

                                </div>

                            }

                            <div className="lineup-option">

                                <Ons.Button modifier="large" onClick={this.handleLineupDataEditorClose}>{_( 'OK' )}</Ons.Button>

                                <Ons.Button modifier="large quiet" onClick={this.handleLineupDataEditorCancel}>{_( 'Abbrechen' )}</Ons.Button>

                            </div>

                        </div>

                    </Ons.Dialog>

                }

            </>

        );

    }

}

export default RosterPlayers;